import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function RelatoriosAuditoriaPage() {
  const [periodo, setPeriodo] = useState('30dias');
  const [tipoRelatorio, setTipoRelatorio] = useState('geral');

  const metricas = [
    { titulo: 'Vendas Auditadas', valor: '2.847', variacao: '+12%', icon: 'ri-file-list-3-line', color: 'blue' },
    { titulo: 'Vendas Premiadas', valor: '2.156', variacao: '+8%', icon: 'ri-trophy-line', color: 'emerald' },
    { titulo: 'Fraudes Evitadas', valor: '142', variacao: '-5%', icon: 'ri-shield-check-line', color: 'red' },
    { titulo: 'Impacto Financeiro', valor: 'R$ 487.320', variacao: '+15%', icon: 'ri-money-dollar-circle-line', color: 'orange' },
    { titulo: 'SLA Médio', valor: '2.3h', variacao: '-12%', icon: 'ri-time-line', color: 'purple' },
    { titulo: 'Aprovação Automática', valor: '75.8%', variacao: '+3%', icon: 'ri-robot-line', color: 'teal' }
  ];

  const dadosGrafico = [
    { mes: 'Jul', auditadas: 1850, premiadas: 1420, fraudes: 95 },
    { mes: 'Ago', auditadas: 2100, premiadas: 1580, fraudes: 112 },
    { mes: 'Set', auditadas: 2350, premiadas: 1790, fraudes: 128 },
    { mes: 'Out', auditadas: 2580, premiadas: 1950, fraudes: 135 },
    { mes: 'Nov', auditadas: 2720, premiadas: 2080, fraudes: 140 },
    { mes: 'Dez', auditadas: 2847, premiadas: 2156, fraudes: 142 }
  ];

  const impactoFinanceiro = [
    { categoria: 'Fraudes Bloqueadas', valor: 'R$ 142.580', percentual: 29.2, cor: 'bg-red-500' },
    { categoria: 'Vendas Inválidas', valor: 'R$ 98.450', percentual: 20.2, cor: 'bg-orange-500' },
    { categoria: 'Duplicidades', valor: 'R$ 87.320', percentual: 17.9, cor: 'bg-amber-500' },
    { categoria: 'Documentação Irregular', valor: 'R$ 76.890', percentual: 15.8, cor: 'bg-yellow-500' },
    { categoria: 'Outros', valor: 'R$ 82.080', percentual: 16.9, cor: 'bg-gray-500' }
  ];

  const slaDetalhado = [
    { etapa: 'Recebimento da Venda', tempo: '0.2h', status: 'excelente' },
    { etapa: 'Extração de Dados', tempo: '0.5h', status: 'bom' },
    { etapa: 'Aplicação de Regras', tempo: '0.3h', status: 'excelente' },
    { etapa: 'Auditoria Manual', tempo: '1.1h', status: 'regular' },
    { etapa: 'Aprovação Final', tempo: '0.2h', status: 'excelente' }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      blue: 'bg-blue-500',
      emerald: 'bg-emerald-500',
      red: 'bg-red-500',
      orange: 'bg-orange-500',
      purple: 'bg-purple-500',
      teal: 'bg-teal-500'
    };
    return colors[color as keyof typeof colors];
  };

  const getStatusBadge = (status: string) => {
    const badges = {
      excelente: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Excelente' },
      bom: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Bom' },
      regular: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Regular' }
    };
    const badge = badges[status as keyof typeof badges];
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${badge.bg} ${badge.text}`}>
        {badge.label}
      </span>
    );
  };

  const maxValor = Math.max(...dadosGrafico.map(d => d.auditadas));

  const exportarRelatorio = (formato: 'pdf' | 'excel') => {
    console.log(`Exportando relatório em formato ${formato}`);
    alert(`Relatório exportado em ${formato.toUpperCase()}!`);
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Relatórios de Auditoria</h1>
            <p className="text-sm text-gray-600 mt-1">Análise completa de performance e impacto</p>
          </div>
          <div className="flex items-center space-x-3">
            <select
              value={periodo}
              onChange={(e) => setPeriodo(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="7dias">Últimos 7 dias</option>
              <option value="30dias">Últimos 30 dias</option>
              <option value="90dias">Últimos 90 dias</option>
              <option value="semestre">Último semestre</option>
              <option value="ano">Último ano</option>
            </select>
            <button
              onClick={() => exportarRelatorio('pdf')}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-file-pdf-line"></i>
              </div>
              <span>PDF</span>
            </button>
            <button
              onClick={() => exportarRelatorio('excel')}
              className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-file-excel-2-line"></i>
              </div>
              <span>Excel</span>
            </button>
          </div>
        </div>

        {/* Seletor de Tipo de Relatório */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center space-x-2">
            <button
              onClick={() => setTipoRelatorio('geral')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tipoRelatorio === 'geral' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Visão Geral
            </button>
            <button
              onClick={() => setTipoRelatorio('fraudes')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tipoRelatorio === 'fraudes' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Fraudes Evitadas
            </button>
            <button
              onClick={() => setTipoRelatorio('sla')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tipoRelatorio === 'sla' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              SLA & Performance
            </button>
            <button
              onClick={() => setTipoRelatorio('aprovacao')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tipoRelatorio === 'aprovacao' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Aprovação Automática
            </button>
          </div>
        </div>

        {/* Cards de Métricas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {metricas.map((metrica, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 rounded-lg ${getColorClasses(metrica.color)} flex items-center justify-center`}>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${metrica.icon} text-white text-xl`}></i>
                  </div>
                </div>
                <span className={`text-sm font-semibold ${metrica.variacao.startsWith('+') ? 'text-emerald-600' : metrica.variacao.startsWith('-') && metrica.titulo.includes('SLA') ? 'text-emerald-600' : 'text-red-600'}`}>
                  {metrica.variacao}
                </span>
              </div>
              <p className="text-sm font-medium text-gray-600">{metrica.titulo}</p>
              <p className="text-3xl font-bold text-gray-900 mt-2">{metrica.valor}</p>
            </div>
          ))}
        </div>

        {/* Gráfico de Evolução */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-900">Evolução Mensal</h3>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                <span className="text-gray-600">Auditadas</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-emerald-500 rounded-full"></div>
                <span className="text-gray-600">Premiadas</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                <span className="text-gray-600">Fraudes</span>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-between space-x-4 h-64">
            {dadosGrafico.map((mes, index) => (
              <div key={index} className="flex-1 flex flex-col items-center space-y-2">
                <div className="w-full flex items-end justify-center space-x-1" style={{ height: '200px' }}>
                  <div
                    className="w-1/3 bg-blue-500 rounded-t-lg transition-all hover:bg-blue-600"
                    style={{ height: `${(mes.auditadas / maxValor) * 100}%` }}
                    title={`Auditadas: ${mes.auditadas}`}
                  ></div>
                  <div
                    className="w-1/3 bg-emerald-500 rounded-t-lg transition-all hover:bg-emerald-600"
                    style={{ height: `${(mes.premiadas / maxValor) * 100}%` }}
                    title={`Premiadas: ${mes.premiadas}`}
                  ></div>
                  <div
                    className="w-1/3 bg-red-500 rounded-t-lg transition-all hover:bg-red-600"
                    style={{ height: `${(mes.fraudes / maxValor) * 100}%` }}
                    title={`Fraudes: ${mes.fraudes}`}
                  ></div>
                </div>
                <span className="text-sm font-medium text-gray-600">{mes.mes}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Impacto Financeiro */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">Impacto Financeiro - Fraudes Evitadas</h3>
          <div className="space-y-4">
            {impactoFinanceiro.map((item, index) => (
              <div key={index}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700">{item.categoria}</span>
                  <span className="text-sm font-bold text-gray-900">{item.valor}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                  <div
                    className={`h-full ${item.cor} transition-all duration-500`}
                    style={{ width: `${item.percentual}%` }}
                  ></div>
                </div>
                <p className="text-xs text-gray-500 mt-1">{item.percentual}% do total</p>
              </div>
            ))}
          </div>
          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <span className="text-lg font-bold text-gray-900">Total Economizado</span>
              <span className="text-2xl font-bold text-emerald-600">R$ 487.320</span>
            </div>
          </div>
        </div>

        {/* SLA Detalhado */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">SLA Médio por Etapa</h3>
          <div className="space-y-4">
            {slaDetalhado.map((etapa, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex-1">
                  <p className="text-sm font-semibold text-gray-900">{etapa.etapa}</p>
                </div>
                <div className="flex items-center space-x-4">
                  <span className="text-lg font-bold text-gray-900">{etapa.tempo}</span>
                  {getStatusBadge(etapa.status)}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <span className="text-lg font-bold text-gray-900">SLA Médio Total</span>
              <div className="flex items-center space-x-3">
                <span className="text-2xl font-bold text-blue-600">2.3h</span>
                <span className="text-sm font-semibold text-emerald-600">-12% vs mês anterior</span>
              </div>
            </div>
          </div>
        </div>

        {/* Índice de Aprovação Automática */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">Índice de Aprovação Automática</h3>
          <div className="flex items-center justify-center mb-6">
            <div className="relative w-48 h-48">
              <svg className="w-full h-full transform -rotate-90">
                <circle
                  cx="96"
                  cy="96"
                  r="80"
                  stroke="#e5e7eb"
                  strokeWidth="16"
                  fill="none"
                />
                <circle
                  cx="96"
                  cy="96"
                  r="80"
                  stroke="#10b981"
                  strokeWidth="16"
                  fill="none"
                  strokeDasharray={`${75.8 * 5.03} ${100 * 5.03}`}
                  strokeLinecap="round"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center flex-col">
                <span className="text-4xl font-bold text-gray-900">75.8%</span>
                <span className="text-sm text-gray-600 mt-1">Automático</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-4 bg-emerald-50 rounded-lg">
              <p className="text-sm font-medium text-emerald-700 mb-1">Aprovação Automática</p>
              <p className="text-2xl font-bold text-emerald-900">2.156</p>
            </div>
            <div className="text-center p-4 bg-orange-50 rounded-lg">
              <p className="text-sm font-medium text-orange-700 mb-1">Auditoria Manual</p>
              <p className="text-2xl font-bold text-orange-900">691</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
